import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import _ from 'lodash';
import config from '../../config'
import * as Api from "../../common/Api";

const initialState = {
    searchCriteria: undefined,
    selectedId: [],
    currentPage: 1,
    pageSize: 20,
    order: {by: 'created', direction: 'DESC'},
    loading: false,
    pollingLoading: false,
    totalCount: 0,
    reload: false,
    alertMessage: undefined,
    successMessage: undefined,
    entityVerificationsArray: [],
};

export const getEntityVerificationsCount = createAsyncThunk('entityVerifications/count', async (payload, { getState, rejectWithValue }) => {
    try {
        const countResult = await Api.get(true,
            `${config.services.ATLAS.apiUrl}/managed-entity-verifications/count`);
        return countResult.totalCount;
    }
    catch (err){
        console.log(`Error in getDenormCompanies and err.response.body.message = ${err.response.body.message}`);
        return rejectWithValue(err.response.body.message);
    }
});

export const getDenormCompanies = createAsyncThunk('entityVerifications/get-all', async (pageSelector, { getState, rejectWithValue }) => {
    try {
        const {pageNumber, pageSize} = pageSelector;
        const companiesResult = await Api.get(true,
            `${config.services.ATLAS.apiUrl}/managed-entity-verifications?pageNumber=${pageNumber}&pageSize=${pageSize}`);
        return { data: companiesResult, isPolling: pageSelector.isPolling };
    }
    catch (err){
        console.log(`Error in getDenormCompanies and err.response.body.message = ${err.response.body.message}`);
        return rejectWithValue(err.response.body.message);
    }
});

export const getDenormByCompanyId = createAsyncThunk('entityVerifications/get-by-company-id', async (id, { getState, rejectWithValue }) => {
    try {
        const companiesResult = await Api.get(true,
            `${config.services.ATLAS.apiUrl}/managed-entity-verifications/company/${id}`);
        return companiesResult;
    }
    catch (err){
        console.log(`Error in getDenormCompanyById and err.response.body.message = ${err.response.body.message}`);
        return rejectWithValue(err.response.body.message);
    }
});

export const getEntityVerificationsWithFilter = createAsyncThunk('entityVerifications/get-all-with-filter', async (filter) => {
    const GET_URL = `${config.services.ATLAS.apiUrl}/managed-entity-verifications`;
    const entityVerifications = await Api.get(true, GET_URL, filter);
    return entityVerifications ;
});

export const denormCompanyUpdate = createAsyncThunk('entityVerifications/update-record-validation', async (cellUpdate, {rejectWithValue}) => {
    try {
        const POST_URL = `${config.services.ATLAS.apiUrl}/managed-entity-verifications`;
        const entityVerifications = await Api.post(true, POST_URL, {options: {}, data: cellUpdate});
        
        // The server should return the updated entity verification with the _updating array
        // containing the current update status
        if (!entityVerifications || !entityVerifications._updating) {
            throw new Error('Invalid response from server');
        }
        
        return entityVerifications;
    }
    catch (err) {
        console.log(`Error in denormCompanyEdit and err.response.body.message = ${err.response?.body?.message || err.message}`);
        return rejectWithValue(err.response?.body?.message || err.message);
    }
});

export const dismissMessage = createAsyncThunk('entityVerifications/dismissMessage', async (id, {rejectWithValue}) => {
    try {
        const POST_URL = `${config.services.ATLAS.apiUrl}/managed-entity-verifications/messages/${id}/dismiss`;
        const entityVerfications = await Api.post(true, POST_URL, {options: {}});
        return entityVerfications;
        // }
    }
    catch (err){
        console.log(`Error in dismiss message and err.response.body.message = ${err.response.body.message}`);
        return rejectWithValue(err.response.body.message);
    }
});


const entityVerificationsSlice = createSlice({
    name: 'entityVerificationSlice', initialState,
    reducers: {
        clearSelected: {
            reducer(state, action) {
                state.selectedId = [];
                state.selectedMatchTypes = [];
            }
        },
        setCurrentPage: {
            reducer(state, action) {
                state.currentPage = action.payload;
            }
        },
        setOrder: {
            reducer(state, action) {
                state.order.by = _.get(action.payload, 'by');
                state.order.direction = _.get(action.payload, 'direction');
            }
        },
        updateRowData: {
            reducer(state, action) {
                state.entityVerificationsArray = action.payload;
            }
        },
        updateIndividualRow: {
            reducer(state, action) {
                const { rowId, updatedRow } = action.payload;
                const rowIndex = state.entityVerificationsArray.findIndex(row => row.id === rowId);
                
                if (rowIndex >= 0) {
                    state.entityVerificationsArray[rowIndex] = updatedRow;
                }
            }
        },
        updateFromServer: {
            reducer(state, action) {
                // Merge server data with existing data, preserving any local _updating arrays
                if (action.payload && Array.isArray(action.payload)) {
                    // Only update rows that have different _updating arrays from server
                    action.payload.forEach((serverRow, index) => {
                        if (index < state.entityVerificationsArray.length) {
                            const existingRow = state.entityVerificationsArray[index];
                            const serverUpdating = serverRow._updating || [];
                            const existingUpdating = existingRow._updating || [];
                            
                            // Only update if the _updating arrays are different
                            if (JSON.stringify(serverUpdating) !== JSON.stringify(existingUpdating)) {
                                state.entityVerificationsArray[index] = {
                                    ...existingRow,
                                    ...serverRow,
                                    _updating: serverUpdating
                                };
                            }
                        }
                    });
                }
            }
        },
       /* setSelectedId: {
            reducer(state, action) {
                if (action?.payload?.id) {
                    if (state.selectedId.indexOf(action.payload.id) >= 0) {
                        state.selectedId.splice(state.selectedId.indexOf(action.payload.id), 1);
                        state.selectedRecordValidations.splice(state.selectedRecordValidations.indexOf((list) => list.id === action.payload.id), 1);
                    }
                    if (action.payload.isChecked === true) {
                        state.selectedId.push(action.payload.id);
                        state.selectedRecordValidations.push(action.payload);
                    }
                }
            }
        }, */
        setSearchCriteria: {
            reducer(state, action) {
                state.searchCriteria = action.payload;
                state.currentPage = 1;
            }
        },
        resetCreateEntityValiationsState: {
            reducer(state, action) {
                state.loading = false;
                state.reset = true;
                state.alertMessage = undefined;
                state.successMessage = undefined;
            }
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDenormCompanies.pending, (state, action) => {
                if (action.meta.arg.isPolling) {
                    state.pollingLoading = true;
                } else {
                    state.loading = true;
                }
                state.alertMessage = undefined;
                state.successMessage = undefined;
            })
            .addCase(getDenormCompanies.fulfilled, (state, action) => {
                if (action.payload.isPolling) {
                    state.pollingLoading = false;
                } else {
                    state.loading = false;
                }
                if (action.payload.data) {
                    state.entityVerificationsArray = action.payload.data;
                    state.download = undefined;
                }
                state.alertMessage = undefined;
                state.successMessage = undefined;
            })
            .addCase(getDenormCompanies.rejected, (state, action) => {
                if (action.meta.arg.isPolling) {
                    state.pollingLoading = false;
                } else {
                    state.loading = false;
                }
                state.alertMessage = undefined;
                state.successMessage = undefined;
            })
            .addCase(getDenormByCompanyId.rejected, (state, action) => {
                state.loading = false;
                state.alertMessage = action.payload;
            })
            .addCase(getDenormByCompanyId.pending, (state, action) => {
                state.loading = true;
                state.alertMessage = undefined;
                state.successMessage = undefined;
            })
            .addCase(getDenormByCompanyId.fulfilled, (state, action) => {
                state.loading = false;
                if (action.payload) {
                    state.entityVerificationsArray = action.payload;
                    state.download = undefined;
                }

                state.alertMessage = undefined;
                state.successMessage = undefined;
            })
            .addCase(denormCompanyUpdate.pending, (state, action) => {
                state.loading = true;
                
                // Set the _updating array when the update starts
                const rowId = action.meta.arg.entityVerificationId;
                const attributeDenormPrefix = action.meta.arg.attributeDenormPrefix;
                const rowIndex = state.entityVerificationsArray.findIndex(row => row.id === rowId);
                
                if (rowIndex >= 0) {
                    const existingRow = state.entityVerificationsArray[rowIndex];
                    const existingUpdating = existingRow._updating || [];
                    
                    // Add the new update to the _updating array
                    const newUpdating = [
                        ...existingUpdating,
                        {
                            attributeDenormPrefix: attributeDenormPrefix,
                            statusId: 'UPDATING'
                        }
                    ];
                    
                    state.entityVerificationsArray[rowIndex] = {
                        ...existingRow,
                        _updating: newUpdating
                    };
                }
            })
            .addCase(denormCompanyUpdate.fulfilled, (state, action) => {
                state.loading = false;
                if(action.payload) {
                    const rowId = action.meta.arg.entityVerificationId;
                    const rowIndex = state.entityVerificationsArray.findIndex(row => row.id === rowId);
                    
                    if (rowIndex >= 0) {
                        const existingRow = state.entityVerificationsArray[rowIndex];
                        const serverUpdating = action.payload._updating || [];
                        const existingUpdating = existingRow._updating || [];
                        
                        // Only update if the _updating arrays are different
                        if (JSON.stringify(serverUpdating) !== JSON.stringify(existingUpdating)) {
                            // Update only the _updating array and any specific fields that changed
                            // Don't replace the entire row object to minimize re-renders
                            state.entityVerificationsArray[rowIndex] = {
                                ...existingRow,
                                _updating: serverUpdating
                            };
                            
                            // Also update any specific attribute fields that might have changed
                            const attributeDenormPrefix = action.meta.arg.attributeDenormPrefix;
                            if (action.payload[attributeDenormPrefix] !== undefined) {
                                state.entityVerificationsArray[rowIndex][attributeDenormPrefix] = action.payload[attributeDenormPrefix];
                            }
                            if (action.payload[attributeDenormPrefix + 'Id'] !== undefined) {
                                state.entityVerificationsArray[rowIndex][attributeDenormPrefix + 'Id'] = action.payload[attributeDenormPrefix + 'Id'];
                            }
                            if (action.payload[attributeDenormPrefix + 'Verified'] !== undefined) {
                                state.entityVerificationsArray[rowIndex][attributeDenormPrefix + 'Verified'] = action.payload[attributeDenormPrefix + 'Verified'];
                            }
                            if (action.payload[attributeDenormPrefix + 'Invalidated'] !== undefined) {
                                state.entityVerificationsArray[rowIndex][attributeDenormPrefix + 'Invalidated'] = action.payload[attributeDenormPrefix + 'Invalidated'];
                            }
                            if (action.payload[attributeDenormPrefix + 'VerifiedBy'] !== undefined) {
                                state.entityVerificationsArray[rowIndex][attributeDenormPrefix + 'VerifiedBy'] = action.payload[attributeDenormPrefix + 'VerifiedBy'];
                            }
                            if (action.payload[attributeDenormPrefix + 'InvalidatedReason'] !== undefined) {
                                state.entityVerificationsArray[rowIndex][attributeDenormPrefix + 'InvalidatedReason'] = action.payload[attributeDenormPrefix + 'InvalidatedReason'];
                            }
                        }
                    }
                }
            })
            .addCase(denormCompanyUpdate.rejected, (state, action) => {
                state.loading = false;
                state.alertMessage = action.payload;
            })
            .addCase(getEntityVerificationsCount.pending, (state, action) => {
                state.loading = true;
                state.alertMessage = undefined;
                state.successMessage = undefined;
            })
            .addCase(getEntityVerificationsCount.fulfilled, (state, action) => {
                state.loading = false;
                if (action.payload !== undefined) {
                    state.totalCount = action.payload;
                }

                state.alertMessage = undefined;
                state.successMessage = undefined;
            })
            .addCase(getEntityVerificationsCount.rejected, (state, action) => {
                state.loading = false;

                state.alertMessage = 'Unable to retrieve overall entity validation count.';
                state.successMessage = undefined;
            })
            .addCase(getEntityVerificationsWithFilter.pending, (state, action) => {
                state.loading = true;

                state.alertMessage = undefined;
                state.successMessage = undefined;
            })
            .addCase(getEntityVerificationsWithFilter.fulfilled, (state, action) => {
                state.loading = false;
                if (action.payload) {
                    state.managedMatchTypes = action.payload;
                    state.download = undefined;
                }
                state.alertMessage = undefined;
                state.successMessage = undefined;
            })
            .addCase(getEntityVerificationsWithFilter.rejected, (state, action) => {
                state.loading = false;
                state.alertMessage = undefined;
                state.successMessage = undefined;
            })
            .addCase(dismissMessage.pending, (state, action) => {
                state.loading = true;
            })
            .addCase(dismissMessage.fulfilled, (state, action) => {
                state.loading = false;
                if(action.payload && state.entityVerificationsArray.length > 0) {
                    const index = state.entityVerificationsArray.findIndex(ev =>
                        action.payload._updating &&
                        action.payload._updating.length > 0 &&
                        ev.id === action.payload._updating[0].entityVerificationId);
                    if (index >= 0) {
                        state.entityVerificationsArray[index] = Object.assign({},
                            state.entityVerificationsArray[index],
                            action.payload
                        );
                    }
                }
            })
            .addCase(dismissMessage.rejected, (state, action) => {
                state.loading = false;
                state.alertMessage = action.payload;
            });
    }
});


export const {
    setCurrentPage,
    setOrder,
    setSelectedId,
    clearSelected,
    setSearchCriteria,
    updateRowData,
    updateIndividualRow,
    updateFromServer
} = entityVerificationsSlice.actions;
export default entityVerificationsSlice.reducer;
